var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400,266.67c-73.64,0-133.33,59.7-133.33,133.33s59.7,133.33,133.33,133.33,133.33-59.7,133.33-133.33-59.7-133.33-133.33-133.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240,0C107.45,0,0,107.45,0,240v320c0,132.55,107.45,240,240,240h320c132.55,0,240-107.45,240-240V240C800,107.45,692.55,0,560,0H240ZM213.33,400c0-103.09,83.57-186.67,186.67-186.67s186.67,83.57,186.67,186.67-83.57,186.67-186.67,186.67-186.67-83.57-186.67-186.67ZM586.67,213.33h53.33v-53.33h-53.33v53.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.529b27c9331f4184a4f503304a5843c5.svg";
export { ForwardRef as ReactComponent };